export default __webpack_public_path__ + "static/media/404.d17c4ba2.png";